import React, { FC, ReactNode } from "react";
import ToolbarBottom from "./ToolbarBottom";
import Navbar from "../F7/Navbar";

const Page: FC<{
  title: string;
  noToolbar?: boolean;
  navbarLeft?: ReactNode;
  navbarRight?: ReactNode;
  children: ReactNode;
}> = ({ children, title, noToolbar, navbarLeft, navbarRight }) => {
  return (
    <div className="pages">
      <div className="page toolbar-fixed navbar-fixed">
        <Navbar left={navbarLeft} right={navbarRight}>
          {title}
        </Navbar>
        <div className="page-content">{children}</div>
        {noToolbar ? null : <ToolbarBottom />}
      </div>
    </div>
  );
};

export default Page;
